import React from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { Container, Grid, useMantineTheme, Box, Group, Flex } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
import { IconFilter, IconReload } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";

import { BE_API_TWO, utils, role } from "../../utils/globalVariables";
import { regexNoStriped, getPropInSubLevelRole, safetyDecodeJWT, isoDateToSqlDate } from "../../utils/globalFunctions";

import AmountOfData from "../../components/general/AmountOfData";
import ActionIconComponent from "../../components/general/ActionIconComponent";
import NoData from "../../components/general/NoData";
import WrapperUtils from "../../layout/WrapperUtils";

import SudahDiambilCard from "./SudahDiambilCard";
import SudahDiambilSelected from "./SudahDiambilSelected";
import ProjectNotaFilterBayar from "../trxProjectNota/ProjectNotaFilterBayar";
import FeedbackDrawer from "../home/feedback/FeedbackDrawer";
import SearchInputComponent from "../../components/general/SearchInputComponent";

const SudahDiambilIndex = ({
    stateMenu,
    stateSubMenu,
    stateTab,
    fnRefreshNumber
}) => {

    const mountedRef = React.useRef(true);

    const navigate = useNavigate();
    const theme = useMantineTheme();
    const matchesMinMD = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorGetData: 'sudahDiambilIndex-1',
    })

    const filterDefaultRef = React.useRef({
        barangCategory: utils.flagAll,

        tanggalNotaDari: null,
        tanggalNotaSampai: null,

        tanggalAmbilDari: null,
        tanggalAmbilSampai: null,

        tanggalBayarDari: null,
        tanggalBayarSampai: null,

        tanggalDeadlinePengecekanDari: null,
        tanggalDeadlinePengecekanSampai: null,

        tanggalDeadlineSelesaiDari: null,
        tanggalDeadlineSelesaiSampai: null,

        deadlinePengecekan: utils.flagAll,
        deadlineSelesai: utils.flagAll,

        deadlinePengecekanSudah: utils.flagAll,
        deadlineSelesaiSudah: utils.flagAll,

        teknisi: {
            id: '',
            name: '',
            subLevel: ''
        },

        isSudahRating: utils.flagAll,
        isLunas: utils.flagAll,
    })

    const sortList = {
        tanggalNota: {
            slug: 'tanggal_nota',
            caption: 'Tanggal Masuk',
            type: utils.sortType.date.slug
        },
        tanggalDateLinePengecekan: {
            slug: 'date_line_pengecekan',
            caption: 'Deadline Pengecekan',
            type: utils.sortType.date.slug
        },
        tanggalDateLineSelesai: {
            slug: 'date_line_selesai',
            caption: 'Deadline Selesai',
            type: utils.sortType.date.slug
        },
        customerName: {
            slug: 'customer_name',
            caption: 'Customer',
            type: utils.sortType.string.slug
        },
        projectId: {
            slug: 'project_id',
            caption: 'No Nota',
            type: utils.sortType.string.slug
        },
        barangCategoryName: {
            slug: 'barang_category_name',
            caption: 'Kategori Barang',
            type: utils.sortType.string.slug
        },
        barangNama: {
            slug: 'barang_nama',
            caption: 'Barang',
            type: utils.sortType.string.slug
        },
        barangKeluhan: {
            slug: 'barang_keluhan',
            caption: 'Keluhan',
            type: utils.sortType.string.slug
        },
        teknisi: {
            slug: 'ms_u_penerima_rekomendasi.user_name',
            caption: 'Teknisi',
            type: utils.sortType.string.slug
        },
    }

    const [data, setData] = React.useState({
        data: [],
        dataCount: 0,
        dataFlag: 'idle',
        dataLoading: false,
        dataRefresh: new Date(),
        dataOffset: 0,
        dataSortSelected: sortList.tanggalNota,
        dataSearchInputForBE: '',

        feedbackData: null,
        feedbackModal: false,
        feedbackTriggerUpdate: new Date(),

        filterData: {
            drawer: false,
            barangCategory: filterDefaultRef.current.barangCategory,

            tanggalNotaDari: filterDefaultRef.current.tanggalNotaDari,
            tanggalNotaSampai: filterDefaultRef.current.tanggalNotaSampai,

            tanggalAmbilDari: filterDefaultRef.current.tanggalAmbilDari,
            tanggalAmbilSampai: filterDefaultRef.current.tanggalAmbilSampai,

            tanggalBayarDari: filterDefaultRef.current.tanggalBayarDari,
            tanggalBayarSampai: filterDefaultRef.current.tanggalBayarSampai,

            tanggalDeadlinePengecekanDari: filterDefaultRef.current.tanggalDeadlinePengecekanDari,
            tanggalDeadlinePengecekanSampai: filterDefaultRef.current.tanggalDeadlinePengecekanSampai,

            tanggalDeadlineSelesaiDari: filterDefaultRef.current.tanggalDeadlineSelesaiDari,
            tanggalDeadlineSelesaiSampai: filterDefaultRef.current.tanggalDeadlineSelesaiSampai,

            deadlinePengecekan: filterDefaultRef.current.deadlinePengecekan,
            deadlineSelesai: filterDefaultRef.current.deadlineSelesai,

            deadlinePengecekanSudah: filterDefaultRef.current.deadlinePengecekanSudah,
            deadlineSelesaiSudah: filterDefaultRef.current.deadlineSelesaiSudah,

            teknisi: safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappl') === role.teknisi.slugLevel ?
                {
                    id: safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappi'),
                    name: safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappn'),
                    subLevel: safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl')
                }
                :
                filterDefaultRef.current.teknisi,

            isSudahRating: filterDefaultRef.current.isSudahRating,
            isLunas: filterDefaultRef.current.isLunas,
        },
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const fnSort = (stateSortSelected) => {
        setData(d => ({
            ...d,
            dataLoading: true,
            dataSortSelected: {
                ...d.dataSortSelected,
                slug: d.dataSortSelected.slug[0] === '-' ? stateSortSelected.slug : '-' + stateSortSelected.slug,
                caption: stateSortSelected.caption,
                type: stateSortSelected.type
            }
        }));
    };

    const AmountOfDataComponent = () => {
        return (
            <AmountOfData
                stateDataLimit={utils.dataLimit}
                stateDataOffset={data.dataOffset}
                stateAmountDataAll={data.dataCount}
                stateDataFlag={data.dataFlag}
                stateSuffix=''

                fnFirstData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}

                fnLastData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}

                fnPreviousData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}

                fnNextData={(stateNewOffset) => setData(d => ({
                    ...d,
                    dataLoading: true,
                    dataRefresh: new Date(),
                    dataOffset: stateNewOffset
                }))}
            />
        )
    }

    React.useEffect(() => {
        setData(d => ({ ...d, dataLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('data_limit', utils.dataLimit);
        formDT.append('data_offset', data.dataOffset);
        formDT.append('order_by', regexNoStriped(data.dataSortSelected.slug));
        formDT.append('order_type', data.dataSortSelected.slug[0] === '-' ? 'asc' : 'desc');

        formDT.append('flag_all', utils.flagAll);
        formDT.append('filter_search', data.dataSearchInputForBE);

        formDT.append('project_process', utils.projectProcess.sudah_diambil.value);
        formDT.append('project_is_cancel', '0');

        formDT.append('filter_barang_category', data.filterData.barangCategory);

        formDT.append('filter_tanggal_nota_dari', data.filterData.tanggalNotaDari ? isoDateToSqlDate(data.filterData.tanggalNotaDari, utils.flagAll) : utils.flagAll);
        formDT.append('filter_tanggal_nota_sampai', data.filterData.tanggalNotaSampai ? isoDateToSqlDate(data.filterData.tanggalNotaSampai, utils.flagAll) : utils.flagAll);

        formDT.append('filter_tanggal_ambil_dari', data.filterData.tanggalAmbilDari ? isoDateToSqlDate(data.filterData.tanggalAmbilDari, utils.flagAll) : utils.flagAll);
        formDT.append('filter_tanggal_ambil_sampai', data.filterData.tanggalAmbilSampai ? isoDateToSqlDate(data.filterData.tanggalAmbilSampai, utils.flagAll) : utils.flagAll);

        formDT.append('filter_tanggal_bayar_dari', data.filterData.tanggalBayarDari ? isoDateToSqlDate(data.filterData.tanggalBayarDari, utils.flagAll) : utils.flagAll);
        formDT.append('filter_tanggal_bayar_sampai', data.filterData.tanggalBayarSampai ? isoDateToSqlDate(data.filterData.tanggalBayarSampai, utils.flagAll) : utils.flagAll);

        formDT.append('use_tanggal_ambil_bayar', 1);

        formDT.append('filter_tanggal_deadline_pengecekan_dari', data.filterData.tanggalDeadlinePengecekanDari ? isoDateToSqlDate(data.filterData.tanggalDeadlinePengecekanDari, utils.flagAll) : utils.flagAll);
        formDT.append('filter_tanggal_deadline_pengecekan_sampai', data.filterData.tanggalDeadlinePengecekanSampai ? isoDateToSqlDate(data.filterData.tanggalDeadlinePengecekanSampai, utils.flagAll) : utils.flagAll);
        formDT.append('filter_tanggal_deadline_selesai_dari', data.filterData.tanggalDeadlineSelesaiDari ? isoDateToSqlDate(data.filterData.tanggalDeadlineSelesaiDari, utils.flagAll) : utils.flagAll);
        formDT.append('filter_tanggal_deadline_selesai_sampai', data.filterData.tanggalDeadlineSelesaiSampai ? isoDateToSqlDate(data.filterData.tanggalDeadlineSelesaiSampai, utils.flagAll) : utils.flagAll);

        formDT.append('filter_deadline_pengecekan', data.filterData.deadlinePengecekan);
        formDT.append('filter_deadline_selesai', data.filterData.deadlineSelesai);

        formDT.append('filter_deadline_pengecekan_sudah', data.filterData.deadlinePengecekanSudah);
        formDT.append('filter_deadline_selesai_sudah', data.filterData.deadlineSelesaiSudah);

        formDT.append('filter_teknisi_id', data.filterData.teknisi.id);
        formDT.append('filter_is_sudah_rating', data.filterData.isSudahRating);
        formDT.append('filter_is_lunas', data.filterData.isLunas);

        axios({
            method: 'post',
            url: BE_API_TWO + '/list_project_batch_1',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, dataLoading: false }));

            if (response.data.flag_status === 'isset') {
                setData(d => ({
                    ...d,
                    data: response.data.data,
                    dataCount: response.data.data_count,
                    dataFlag: response.data.data.length > 0 ? true : false,
                }));
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                dataLoading: false,
            }));

            notifications.show({
                id: notificationId.current.errorGetData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }, [
        handleSetLoginContext,
        loginContext.syswebapp,
        data.dataRefresh,
        data.dataSearchInputForBE,
        data.dataSortSelected.slug,
        data.dataOffset,

        data.filterData.barangCategory,
        data.filterData.tanggalNotaDari,
        data.filterData.tanggalNotaSampai,

        data.filterData.tanggalAmbilDari,
        data.filterData.tanggalAmbilSampai,

        data.filterData.tanggalBayarDari,
        data.filterData.tanggalBayarSampai,

        data.filterData.tanggalDeadlinePengecekanDari,
        data.filterData.tanggalDeadlinePengecekanSampai,
        data.filterData.tanggalDeadlineSelesaiDari,
        data.filterData.tanggalDeadlineSelesaiSampai,
        data.filterData.deadlinePengecekan,
        data.filterData.deadlineSelesai,
        data.filterData.deadlinePengecekanSudah,
        data.filterData.deadlineSelesaiSudah,
        data.filterData.teknisi.id,
        data.filterData.isSudahRating,
        data.filterData.isLunas,
    ])

    return (
        <React.Fragment>
            <WrapperUtils
                stateDataLoading={data.dataLoading}
            >
                <Group spacing='xs' noWrap>
                    <ActionIconComponent
                        stateVariant='light'
                        stateRadius='xl'
                        stateTitle='Filter'
                        stateSize='lg'
                        fnOnClick={() => setData(d => ({
                            ...d,
                            filterData: {
                                ...d.filterData,
                                drawer: true
                            }
                        }))}

                        StateIcon={IconFilter}
                        stateIconSize='1.125rem'
                        stateIconStrokeWidth={1.25}
                        stateIconStyle={{
                            color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                        }}
                    />

                    <ActionIconComponent
                        stateVariant='light'
                        stateRadius='xl'
                        stateTitle='Reload Data'
                        stateSize='lg'
                        fnOnClick={() => setData(d => ({ ...d, dataLoading: true, dataRefresh: new Date() }))}

                        StateIcon={IconReload}
                        stateIconSize='1.125rem'
                        stateIconStrokeWidth={1.25}
                        stateIconStyle={{
                            color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                        }}
                    />

                    <SearchInputComponent
                        statePlaceHolder='Search Project'
                        fnDoSearch={(val) => setData(d => ({
                            ...d,
                            dataOffset: 0,
                            dataSearchInputForBE: val,
                            dataRefresh: new Date(),
                        }))}
                    />
                </Group>

                {matchesMinMD &&
                    <Flex
                        sx={{ flex: 1 }}
                        justify="flex-end"
                        align="center"
                        direction="row"
                        wrap="nowrap"
                    >
                        <AmountOfDataComponent />
                    </Flex>
                }
            </WrapperUtils>

            <Container fluid>
                <Grid my={0}>
                    {data.data.length <= 0 && data.dataFlag !== 'idle' &&
                        <Grid.Col span={12}>
                            <NoData />
                        </Grid.Col>
                    }

                    {data.data.length > 0 &&
                        <Grid.Col
                            span={12}
                            py={0}
                        >
                            <Box mt='md'>
                                <SudahDiambilCard
                                    stateData={data.data}
                                    stateSortList={sortList}
                                    stateSortSelected={data.dataSortSelected}
                                    fnSort={(val) => {
                                        fnSort(val);
                                    }}

                                    fnSelectedData={(arrayVal) => {
                                        navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateMenu}/${stateSubMenu}/${stateTab}/${arrayVal.project_id}`, { replace: true });

                                        setData(d => ({
                                            ...d,
                                            dataRefresh: new Date(),
                                            dataLoading: true,
                                            feedbackData: arrayVal
                                        }));
                                        // ! apakah ini perlu ?perlu update index sewaktu pilih nota ?
                                    }}

                                    fnFeedback={(arrayVal) => {
                                        setData(d => ({
                                            ...d,
                                            feedbackData: arrayVal,
                                            feedbackTriggerUpdate: new Date(),
                                            feedbackModal: true
                                        }))
                                    }}
                                />
                            </Box>
                        </Grid.Col>
                    }

                    {data.data.length > 0 &&
                        <Grid.Col span={12} className='amountOfDataBottom'>
                            <Group mt='xs' mb='md' position='apart'>
                                <Box>&nbsp;</Box>

                                <AmountOfDataComponent />
                            </Group>
                        </Grid.Col>
                    }
                </Grid>
            </Container>

            <ProjectNotaFilterBayar
                stateShow={data.filterData.drawer}
                fnShow={() => setData(d => ({
                    ...d,
                    filterData: {
                        ...d.filterData,
                        drawer: false
                    }
                }))}

                stateDefaultFilter={{
                    ...filterDefaultRef.current,
                }}

                stateFilter={{
                    barangCategory: data.filterData.barangCategory,

                    tanggalNotaDari: data.filterData.tanggalNotaDari,
                    tanggalNotaSampai: data.filterData.tanggalNotaSampai,

                    tanggalAmbilDari: data.filterData.tanggalAmbilDari,
                    tanggalAmbilSampai: data.filterData.tanggalAmbilSampai,

                    tanggalBayarDari: data.filterData.tanggalBayarDari,
                    tanggalBayarSampai: data.filterData.tanggalBayarSampai,

                    tanggalDeadlinePengecekanDari: data.filterData.tanggalDeadlinePengecekanDari,
                    tanggalDeadlinePengecekanSampai: data.filterData.tanggalDeadlinePengecekanSampai,
                    tanggalDeadlineSelesaiDari: data.filterData.tanggalDeadlineSelesaiDari,
                    tanggalDeadlineSelesaiSampai: data.filterData.tanggalDeadlineSelesaiSampai,
                    deadlinePengecekan: data.filterData.deadlinePengecekan,
                    deadlineSelesai: data.filterData.deadlineSelesai,

                    deadlinePengecekanSudah: data.filterData.deadlinePengecekanSudah,
                    deadlineSelesaiSudah: data.filterData.deadlineSelesaiSudah,

                    teknisi: data.filterData.teknisi,

                    isSudahRating: data.filterData.isSudahRating,
                    isLunas: data.filterData.isLunas,
                }}

                fnFilter={(obj) => {
                    setData(d => ({
                        ...d,
                        filterData: {
                            ...d.filterData,
                            barangCategory: obj.barangCategory,

                            tanggalNotaDari: obj.tanggalNotaDari,
                            tanggalNotaSampai: obj.tanggalNotaSampai,

                            tanggalAmbilDari: obj.tanggalAmbilDari,
                            tanggalAmbilSampai: obj.tanggalAmbilSampai,

                            tanggalBayarDari: obj.tanggalBayarDari,
                            tanggalBayarSampai: obj.tanggalBayarSampai,

                            tanggalDeadlinePengecekanDari: obj.tanggalDeadlinePengecekanDari,
                            tanggalDeadlinePengecekanSampai: obj.tanggalDeadlinePengecekanSampai,
                            tanggalDeadlineSelesaiDari: obj.tanggalDeadlineSelesaiDari,
                            tanggalDeadlineSelesaiSampai: obj.tanggalDeadlineSelesaiSampai,
                            deadlinePengecekan: obj.deadlinePengecekan,
                            deadlineSelesai: obj.deadlineSelesai,

                            deadlinePengecekanSudah: obj.deadlinePengecekanSudah,
                            deadlineSelesaiSudah: obj.deadlineSelesaiSudah,

                            teknisi: {
                                id: obj.teknisi.id,
                                name: obj.teknisi.name,
                                subLevel: obj.teknisi.subLevel,
                            },

                            isSudahRating: obj.isSudahRating,
                            isLunas: obj.isLunas,

                            drawer: false
                        },

                        dataRefresh: new Date(),
                        dataLoading: true,
                    }));
                }}
            />

            <SudahDiambilSelected
                stateData={{
                    data: data.feedbackData
                }}

                fnCloseDrawer={() => {
                    navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateMenu}/${stateSubMenu}/${stateTab}`, { replace: true });
                }}

                fnSuccessTakesThisProject={() => {
                    setData(d => ({ ...d, dataLoading: true, dataRefresh: new Date() }));
                    fnRefreshNumber();
                }}

                fnRefreshNotaIndex={() => {
                    setData(d => ({ ...d, dataLoading: true, dataRefresh: new Date() }));
                    fnRefreshNumber();
                }}
            />

            <FeedbackDrawer
                stateShow={data.feedbackModal}
                fnShow={(val) => setData(d => ({ ...d, feedbackModal: val }))}
                stateData={{
                    data: data.feedbackData,
                }}
                fnShouldUpdateIndex={(val) => {
                    if (val) {
                        setData(d => ({ ...d, dataRefresh: new Date(), dataLoading: true }));
                    }
                }}
            />
        </React.Fragment>
    )
}

export default SudahDiambilIndex;